import { handleSubmitError } from "components/form";
import handleMultipartSubmit from "../../utils/multipart-submit";

const handleImageSubmit = ({ createAsset, customerId }) => ({ values, setFieldError }) =>
  createAsset({
    variables: {
      assetInput: {
        codename: values.codename,
        image: values.image,
        description: values.description,
        categoryIds: values.categoryIds,
      },
      customerId,
    },
  });

const handleSubmitCompleteForm = ({
  handleSubmit,
  genericErrorMessage,
  genericFileErrorMessage,
  token,
  customerId,
  setProgress,
  mutation,
  history,
  createAsset,
  setLoading,
  graphicSetToEdit,
}) => (values, setFieldError) => {
  const submitAllAssets = values.layouts.map((layout, i) => {
    if (layout.assetId) {
      return { id: layout.assetId };
    }

    const handleAssetSubmit =
      layout.type === "image"
        ? handleImageSubmit({ createAsset, customerId })
        : handleMultipartSubmit({ genericFileErrorMessage, token, customerId, setProgress });

    return handleAssetSubmit({ values: layout.asset, setFieldError }).catch(error => {
      console.error(error);
      setFieldError(`layouts.${i}.asset`, genericFileErrorMessage);
      throw error;
    });
  });

  return Promise.all(submitAllAssets)
    .then(responses => {
      responses.forEach((response, i) => {
        const asset = response.data ? response.data.createAsset : response;
        if (asset.id) {
          values.layouts[i].assetId = asset.id;
        }
        values.layouts[i].type = undefined;
        values.layouts[i].asset = undefined;
      });

      return handleSubmit({
        mutation,
        history,
        graphicSetToEdit,
      })(values, setFieldError).catch(error => {
        console.error(error);
        handleSubmitError({ setFieldError, values, genericErrorMessage, genericFileErrorMessage })(error);
      });
    })
    .catch(error => {
      console.error(error);
      setFieldError("general", genericFileErrorMessage);
    });
};

export default handleSubmitCompleteForm;
